import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: '[xpTable]',
	standalone: true,
	template: '<ng-content></ng-content>',
	styleUrls: ['./xp-table.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpTableComponent { }
